// Profit On Your Terms's Start here (Adam, 5 Oct: the live pre-course module's 19 interactive
// screens carried across as they are, in POYT's look, each member's answers saved and the gate kept;
// docs/data-model.md 10.6.2). Opened from POYT.dc.html's 2 rows ("Deal analysis", "Marketing
// setup"), whose buttons read Start, Continue, then "Go back through it" (index.js startHereRows).
//
//   /poyt/start-here                         where they're up to: the first screen not done
//   /poyt/start-here/<row key>               that row's next screen, or its first once it's done
//   /poyt/start-here/<row key>/<screen key>  the screen; 1 not open yet says so, with the way back
//
// Inside the product's frame (ProductRoute draws the header, the menu with Home marked, the payment
// banner and the read-only line while staff view as a member). No board draws the screens: the
// laptop layout is live's (the list of screens beside the screen), the phone's follows PhoneWeek.dc.html
// (the list folded above the page, the page full width).
import { useEffect } from 'react'
import { useMember } from '../../../app/member.jsx'
import { navigate } from '../../../lib/router.jsx'
import { useViewingAs } from '../../../lib/viewAs.jsx'
import { useProductData } from '../../../product/ProductData.jsx'
import { startHereModel, startHereTarget } from './model.js'
import { Rail } from './Rail.jsx'
import { LockedScreen, Screen } from './Screen.jsx'
import '../../../styles/poyt-start.css'

export default function StartHere({ product, route }) {
  const { data, patch } = useProductData()
  const { me } = useMember()
  const viewingAs = useViewingAs()
  const model = startHereModel(data)
  const rest = route?.rest || []
  const target = startHereTarget(product, model, rest)
  useEffect(() => { if (target) navigate(target, { replace: true }) }, [target])
  if (target) return <div className="ps" aria-busy="true" />

  const entry = model.find(rest[0], rest[1])
  return (
    <div className="ps">
      <Rail product={product} model={model} entry={entry} />
      <div className="ps-main">
        {model.isOpen(entry)
          ? <Screen key={entry.screen.id} product={product} model={model} entry={entry} personId={me.person.id} viewingAs={viewingAs} patch={patch} />
          : <LockedScreen product={product} model={model} entry={entry} />}
      </div>
    </div>
  )
}
